import { IApiError } from '@/models/apiError.model';
import { IAdmin } from '@/models/admins.model';
import { TAdminFiltersValues } from '../helpers/types';
import { IPagination } from '@/models/pagination.model';

export const ADMINS_LIST_SLICE_NAME = 'adminsList';

export interface AdminsListState {
  adminsList: IAdmin[] | null;
  adminDetails: IAdmin | null;
  pagination: IPagination | null;
  isLoading: boolean;
  error: IApiError | null;
  adminFilters: TAdminFiltersValues | null;
}

export const initialState: AdminsListState = {
  adminDetails: null,
  pagination: null,
  adminsList: null,
  isLoading: false,
  adminFilters: null,
  error: null,
};
